<ion-header mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-title>User Filters</ion-title>
    <ion-buttons slot="start">
      <ion-button mode="ios" fill="clear" (click)="dismiss()" tappable>
        <ion-icon color="dark" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list lines="none" mode="ios">
    <h6 class="ion-text-left ion-padding-start">Email Verified</h6>
    <ion-radio-group mode="md" [(ngModel)]="emailVerified">
      <ion-item mode="ios" (click)="emailVerified = 'All'">
        <ion-label>All users</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="All" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="emailVerified = true">
        <ion-label>Verified</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" [value]="true" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="emailVerified = false">
        <ion-label>Not verified</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" [value]="false" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>

    <h6 class="ion-text-left ion-padding-start">Subscriber</h6>
    <ion-radio-group mode="md" [(ngModel)]="subscriber">
      <ion-item mode="ios" (click)="subscriber = 'All'">
        <ion-label>All users</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="All" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="subscriber = true">
        <ion-label>Subscriber</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" [value]="true" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="subscriber = false">
        <ion-label>Not subscriber</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" [value]="false" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>

    <h6 class="ion-text-left ion-padding-start">Verified Account</h6>
    <ion-radio-group mode="md" [(ngModel)]="verifiedAccount">
      <ion-item mode="ios" (click)="verifiedAccount = 'All'">
        <ion-label>All users</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="All" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="verifiedAccount = true">
        <ion-label>Verified</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" [value]="true" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="verifiedAccount = false">
        <ion-label>Not verified</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" [value]="false" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>

    <h6 class="ion-text-left ion-padding-start">Rating</h6>
    <ion-radio-group mode="md" [(ngModel)]="rating">
      @for (r of [5, 4, 3, 2, 1]; track r) {
        <ion-item mode="ios" button="true">
          <ion-label>
            @for (i of [0, 1, 2, 3, 4]; track i) {
              <ion-icon [name]="i < r ? 'star' : 'star-outline'" color="warning"></ion-icon>
            }
            {{ r }} and up
          </ion-label>
          <ion-radio slot="start" mode="md" [value]="r" color="warning"></ion-radio>
        </ion-item>
      }
    </ion-radio-group>

    <h6 class="ion-text-left ion-padding-start">Skills</h6>
    @for (option of skillOptions; track option.value) {
      <ion-item mode="ios" lines="none">
        <ion-checkbox
          justify="space-between"
          mode="md"
          color="warning"
          [checked]="option.checked"
          (ionChange)="updateOption(option, $event)"
        >
          {{ option.label }}
        </ion-checkbox>
      </ion-item>
    }

    <h6 class="ion-text-left ion-padding-start">Gender</h6>
    @for (option of genderOptions; track option.value) {
      <ion-item mode="ios" lines="none">
        <ion-checkbox
          justify="space-between"
          mode="md"
          color="warning"
          [checked]="option.checked"
          (ionChange)="updateOption(option, $event)"
        >
          {{ option.label }}
        </ion-checkbox>
      </ion-item>
    }

    <h6 class="ion-text-left ion-padding-start">Ethnicity</h6>
    @for (option of ethnicityOptions; track option.value) {
      <ion-item mode="ios" lines="none">
        <ion-checkbox
          justify="space-between"
          mode="md"
          color="warning"
          [checked]="option.checked"
          (ionChange)="updateOption(option, $event)"
        >
          {{ option.label }}
        </ion-checkbox>
      </ion-item>
    }

    <h6 class="ion-text-left ion-padding-start">Complexion</h6>
    @for (option of complexionOptions; track option.value) {
      <ion-item mode="ios" lines="none">
        <ion-checkbox
          justify="space-between"
          mode="md"
          color="warning"
          [checked]="option.checked"
          (ionChange)="updateOption(option, $event)"
        >
          {{ option.label }}
        </ion-checkbox>
      </ion-item>
    }

    <h6 class="ion-text-left ion-padding-start">Sort</h6>
    <ion-radio-group mode="md" [(ngModel)]="sortMode">
      <ion-item mode="ios" (click)="sortMode = 'newest'">
        <ion-label>Newest created</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="newest" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="sortMode = 'oldest'">
        <ion-label>Oldest created</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="oldest" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="sortMode = 'recently_updated'">
        <ion-label>Recently updated</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="recently_updated" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="sortMode = 'rating_desc'">
        <ion-label>Rating high to low</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="rating_desc" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="sortMode = 'name_asc'">
        <ion-label>Name A-Z</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="name_asc" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>

    <ion-item mode="ios" class="range-item">
      <ion-label position="stacked">Age</ion-label>
      <ion-range dualKnobs="true" [(ngModel)]="ageRange" [min]="18" [max]="100" step="1" color="warning">
        <ion-label slot="start">{{ ageRange.lower }}</ion-label>
        <ion-label slot="end">{{ ageRange.upper }}</ion-label>
      </ion-range>
    </ion-item>

    <ion-item mode="ios" class="range-item">
      <ion-label position="stacked">Height</ion-label>
      <ion-range dualKnobs="true" [(ngModel)]="heightRange" [min]="3" [max]="8" step="1" color="warning">
        <ion-label slot="start">{{ heightRange.lower }} ft</ion-label>
        <ion-label slot="end">{{ heightRange.upper }} ft</ion-label>
      </ion-range>
    </ion-item>

    <ion-item mode="ios" class="range-item">
      <ion-label position="stacked">Weight</ion-label>
      <ion-range dualKnobs="true" [(ngModel)]="weightRange" [min]="50" [max]="500" step="1" color="warning">
        <ion-label slot="start">{{ weightRange.lower }} lb</ion-label>
        <ion-label slot="end">{{ weightRange.upper }} lb</ion-label>
      </ion-range>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer mode="ios">
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
      <ion-col sizeXl="7" sizeLg="7" sizeMd="10" sizeSm="12" sizeXs="12">
        <ion-row>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="applyFilters()">Apply</ion-button>
          </ion-col>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="clearFilters()">Clear</ion-button>
          </ion-col>
        </ion-row>
        <br />
      </ion-col>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
